/**
 * Service for changing mission type. Handles which events should be available for each missiontype.
 */

var VRC = VRC || {};
VRC.MissionTypeService = (function () {
	var _missionTypeEvents, _missionTypes;

	var init = function () {
		_missionTypes = g_master_data.master_data.voyage_mission_type_list;
		_missionTypeEvents = setActiveEventTypes(g_master_data.master_data.event_type_list);
	};

	var isActiveMissionType = function (missionType, currentVoyage) {
		return missionType === '' || missionType === currentVoyage.getMissionType();
	};

	var findActiveEventTypes = function (missionTypeEvents, activeEventIds) {
		missionTypeEvents = missionTypeEvents || getEventTypes();
		activeEventIds = activeEventIds || [{id: -1}];
		for (var ii = 0; ii < missionTypeEvents.length; ii++) {
			var eventLogType = missionTypeEvents[ii];

			if (eventLogType.isActive) {
				activeEventIds.push(eventLogType);
			}

			if (eventLogType && eventLogType.sub_event_types) {
				activeEventIds = findActiveEventTypes(eventLogType.sub_event_types, activeEventIds);
			}

		}
		return activeEventIds;
	};

    /**
	 * Find active sub-event types for the given parent ID
	 *
     * @param parentEventID
	 *
     * @returns {Array}
	 *
	 * @author EH
	 * @since 16.08.2017
     */
	var findActiveSubEventTypes = function(parentEventID) {

        activeEventIds = [];

		if(parentEventID !== undefined) {

            parentMissionType = getEventTypeById(parentEventID);

            if (parentMissionType && parentMissionType.sub_event_types) {

                for (var ii = 0; ii < parentMissionType.sub_event_types.length; ii++) {

                    var eventLogType = parentMissionType.sub_event_types[ii];

                    if (eventLogType.isActive) {
                        activeEventIds.push(eventLogType);
                    }
                }
            }
        }

        return activeEventIds;
	};

	var setActiveEventTypes = function (missionTypeEvents) {
		var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
		for (var ii = 0; ii < missionTypeEvents.length; ii++) {
			var eventLogType = missionTypeEvents[ii];
            var missionActive = isActiveMissionType(eventLogType.mission_type, currentVoyage);

			if(!missionActive || eventLogType.is_available == "no") {
				eventLogType.isActive = false;
			}
			else {
				eventLogType.isActive = true;
			}

			if (eventLogType && eventLogType.sub_event_types) {
				eventLogType.sub_event_types = setActiveEventTypes(eventLogType.sub_event_types);
			}
		}
		return missionTypeEvents;
	};

	var getEventTypes = function () {
		return _missionTypeEvents;
	};

	var getEventTypeById = function (orgId) {
		var eventType;
		try {
			var id = parseInt(orgId);

			if (isNaN(id)) {
				throw 'is not a number';
			}
			var found = false;
			var ii = 0;

			var eventTypes = findActiveEventTypes();


			while (!found && ii < eventTypes.length) {

				var tempEventType = eventTypes[ii];

				if (tempEventType.id) {
					if (id === parseInt(tempEventType.id)) {
						found = true;
						eventType = tempEventType;
					}
				}
				ii++;
			}

			if (eventType === undefined) {
				throw  'is not in the array';
			}
		}
		catch (e) {
			console.error('Error: could not find the eventType: ' + orgId, e);
		}
		return eventType;
	};

    /**
	 * Get events belonging to a certain type
	 *
     * @param type  the type of category
	 *
	 * @return list of types belonging to type
	 *
	 * @author SBE
	 * @since ??
	 *
     */
	var getEventTypesByType = function (type) {
		type = type.trim();
		var eventTypes = getEventTypes();
		eventTypes = eventTypes.filter(function (eventType) {
			return eventType.event_type === type;
		});

		return eventTypes;
	};

	var getMissionTypes = function () {
		return _missionTypes;
	};

    /**
	 * Checks an event id against events in mission list and retuns
	 * answer on whether event is a sub event or not
	 *
     * @param eventId
     * @param missionTypes
     * @param level
     * @returns {boolean}
	 *
	 * @author EH
	 * @since 18.10.2017
	 *
     */
	var isSubEvent = function(eventId, missionTypeEvents, level) {
        var result = false;
		if(missionTypeEvents === undefined) {
	       level = 0;
		}

        missionTypeEvents = missionTypeEvents || getEventTypes();

        for (var ii = 0; ii < missionTypeEvents.length; ii++) {
            var eventLogType = missionTypeEvents[ii];

            if(eventLogType.id === eventId && level > 0) {
                return true;
			}

            if(eventLogType && eventLogType.sub_event_types) {
                result = isSubEvent(eventId, eventLogType.sub_event_types, level + 1);

                if(result) {
                	return true;
				}
            }
       }

       return false;

	};

    /**
	 * Gets all invalid events based on current voyage log
	 *
     * @returns {Array}
	 *
	 * @author SBE
	 * @since ??
	 *
     */
	var getInvalidEvents = function () {
		var invalidEvents = [];

		var logEntries = VRC.VoyageLogEntryManager.getAll();

		var validTypes = VRC.MissionTypeService.findActiveEventTypes();
		validTypes = $.map(validTypes, function (val) {
			return parseInt(val.id);
		});

		$.each(logEntries, function (index, logEntry) {
			var logEventTypeValue = logEntry.getEventType();

			var isValid = $.inArray(logEventTypeValue, validTypes) !== -1;

			if (!isValid) {
				invalidEvents.push(logEntry);
			}

		});

		return invalidEvents;
	};

    /**
	 * Gets all invalid sub events based on current selected events and sub-events in the voyage log
	 *
     * @returns {Array}
	 *
	 * @author EH
	 * @since 22.08.2017
	 *
     */
    var getInvalidSubEvents = function () {
        var invalidEvents = [];

        var logEntries = VRC.VoyageLogEntryManager.getAll();

        $.each(logEntries, function (index, logEntry) {
            var logEventTypeValue = logEntry.getEventType();
            var subEventTypeValue = logEntry.getSubEventType();

            if (subEventTypeValue > 0) {
              var validTypes = VRC.MissionTypeService.findActiveSubEventTypes(logEventTypeValue);
              validTypes = $.map(validTypes, function (val) {
                  return parseInt(val.id);
              });

              var isValid = $.inArray(subEventTypeValue, validTypes) !== -1;

              if (!isValid) {
                  invalidEvents.push(logEntry);
              }
            }

        });

        return invalidEvents;
    };

	return {
		getEventTypes: getEventTypes,
		getEventTypeById: getEventTypeById,
		getEventTypesByType: getEventTypesByType,
		findActiveEventTypes: findActiveEventTypes,
		findActiveSubEventTypes: findActiveSubEventTypes,
		getMissionTypes: getMissionTypes,
		getInvalidEvents: getInvalidEvents,
		getInvalidSubEvents: getInvalidSubEvents,
		isSubEvent: isSubEvent,
		init: init
	};
})();